// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE

import * as Block from "bs-platform/lib/es6/block.js";
import * as Curry from "bs-platform/lib/es6/curry.js";
import * as React from "react";
import * as Api$Xuder from "../Api.bs.js";
import * as Belt_Option from "bs-platform/lib/es6/belt_Option.js";
import * as ReactModal from "react-modal";
import * as Button$Xuder from "../components/Button.bs.js";
import * as Events$Xuder from "../utils/Events.bs.js";
import * as OrForm$Xuder from "../components/OrForm.bs.js";
import * as AndForm$Xuder from "../components/AndForm.bs.js";
import * as ZcbForm$Xuder from "../components/ZcbForm.bs.js";
import * as Dropdown$Xuder from "../components/Dropdown.bs.js";
import * as GiveForm$Xuder from "../components/GiveForm.bs.js";
import * as TextInput$Xuder from "../components/TextInput.bs.js";
import * as AmericanForm$Xuder from "../components/AmericanForm.bs.js";
import * as EuropeanForm$Xuder from "../components/EuropeanForm.bs.js";
import * as XuderContext$Xuder from "../context/XuderContext.bs.js";

require("./Compose.css");

var contractType = /* array */[
  /* tuple */[
    "zcb",
    "Zero-coupon bond"
  ],
  /* tuple */[
    "european",
    "European Options"
  ],
  /* tuple */[
    "american",
    "American Options"
  ],
  /* tuple */[
    "give",
    "Give Contract"
  ],
  /* tuple */[
    "and",
    "And Contracts"
  ],
  /* tuple */[
    "or",
    "Or Contracts"
  ]
];

ReactModal.setAppElement("#root");

function Compose(Props) {
  var dispatch = XuderContext$Xuder.useDispatch(/* () */0);
  var state = XuderContext$Xuder.useState(/* () */0);
  var match = React.useReducer((function (param, v) {
          return v;
        }), "My Contract");
  var setName = match[1];
  var name = match[0];
  var changeContractType = function ($$event) {
    var match = $$event.target.value;
    var tmp;
    switch (match) {
      case "american" :
          tmp = /* American */2;
          break;
      case "and" :
          tmp = /* AndContracts */4;
          break;
      case "european" :
          tmp = /* European */1;
          break;
      case "give" :
          tmp = /* GiveContract */3;
          break;
      case "or" :
          tmp = /* OrContracts */5;
          break;
      case "zcb" :
          tmp = /* ZCB */0;
          break;
      default:
        tmp = /* NoType */6;
    }
    return Curry._1(dispatch, /* ChangeType */Block.__(1, [tmp]));
  };
  var onSave = function (contract) {
    return Curry._1(dispatch, /* AddContract */Block.__(0, [
                  name,
                  contract
                ]));
  };
  var onDrawImage = function (contract) {
    Curry._1(dispatch, /* AddContract */Block.__(0, [
            name,
            contract
          ]));
    Api$Xuder.drawImage(contract).then((function (imageUrl) {
            return Promise.resolve(Curry._1(dispatch, /* SetImage */Block.__(2, [
                              name,
                              imageUrl
                            ])));
          }));
    return /* () */0;
  };
  var match$1 = state[/* image */1];
  var tmp;
  if (match$1 !== undefined) {
    var match$2 = match$1;
    tmp = React.createElement("div", undefined, React.createElement("div", {
              className: "modal-header"
            }, React.createElement("h3", {
                  className: "modal-title"
                }, match$2[0]), React.createElement(Button$Xuder.make, {
                  children: "Close",
                  onClick: (function (_e) {
                      return Curry._1(dispatch, /* ClearImage */0);
                    })
                })), React.createElement("img", {
              className: "diagram",
              src: match$2[1]
            }));
  } else {
    tmp = null;
  }
  var match$3 = state[/* contractType */2];
  var tmp$1;
  switch (match$3) {
    case /* ZCB */0 :
        tmp$1 = React.createElement(ZcbForm$Xuder.make, {
              onDrawImage: onDrawImage
            });
        break;
    case /* European */1 :
        tmp$1 = React.createElement(EuropeanForm$Xuder.make, {
              onDrawImage: onDrawImage
            });
        break;
    case /* American */2 :
        tmp$1 = React.createElement(AmericanForm$Xuder.make, {
              onDrawImage: onDrawImage
            });
        break;
    case /* GiveContract */3 :
        tmp$1 = React.createElement(GiveForm$Xuder.make, {
              onSave: onSave
            });
        break;
    case /* AndContracts */4 :
        tmp$1 = React.createElement(AndForm$Xuder.make, {
              onDrawImage: onDrawImage
            });
        break;
    case /* OrContracts */5 :
        tmp$1 = React.createElement(OrForm$Xuder.make, {
              onDrawImage: onDrawImage
            });
        break;
    case /* NoType */6 :
        tmp$1 = null;
        break;
    
  }
  return React.createElement("div", {
              className: "single-page compose-page"
            }, React.createElement("div", {
                  className: "content"
                }, React.createElement("h2", undefined, "Compose Contract"), React.createElement(ReactModal.default, {
                      isOpen: Belt_Option.isSome(state[/* image */1]),
                      onAfterOpen: (function (param) {
                          return /* () */0;
                        }),
                      onRequestClose: (function (param) {
                          return /* () */0;
                        }),
                      style: "",
                      contentLabel: "Contract Image",
                      children: tmp
                    }), React.createElement("form", {
                      className: "compose-form",
                      onSubmit: (function (e) {
                          e.preventDefault();
                          return /* () */0;
                        })
                    }, React.createElement("label", {
                          className: "compose-label"
                        }, React.createElement("h5", undefined, "Contract Name"), React.createElement(TextInput$Xuder.make, {
                              value: name,
                              onChange: (function (e) {
                                  return Curry._1(setName, Events$Xuder.targetValue(e));
                                }),
                              name: "Value"
                            })), React.createElement("label", {
                          className: "compose-label"
                        }, React.createElement("h5", undefined, "Contract Type"), React.createElement(Dropdown$Xuder.make, {
                              values: contractType,
                              onChange: changeContractType,
                              name: "contract"
                            })), tmp$1)));
}

var make = Compose;

export {
  contractType ,
  make ,
  
}
/*  Not a pure module */
